import type { AmplitudePayloadResult, AnalyticsLot, AnalyticsOwner, AnalyticsStore, OwnerCallType, OwnerPhoneType } from '~/analytics/composables-types'
import { getGlobalPreviewCatalog } from '~/analytics/composables-types'
import {
  appendLotProductOwnerFields,
  getProductPageSourceFields,
} from '~/composables/useLotProductAnalytics'

interface ClickOwnerCallParams {
  store: AnalyticsStore
  lot?: AnalyticsLot | null
  user?: AnalyticsOwner | null
  callType: OwnerCallType
  phoneType?: OwnerPhoneType | ''
}

export function getOwnerCallType (canDial?: boolean): OwnerCallType {
  return canDial ? 'CALL_PROMT' : 'SHOW_NUMBER'
}

function normalizePhone (phone?: string | number | null): string {
  if (!phone) {
    return ''
  }
  return String(phone).replace(/\D/g, '')
}

export function getOwnerPhoneType ({
  userPhone,
  ownerPhone,
  phonePublic,
  phoneProxy,
}: {
  userPhone?: string | number | null
  ownerPhone?: string | number | null
  phonePublic?: string | number | null
  phoneProxy?: string | number | null
}): OwnerPhoneType | '' {
  if (!ownerPhone) {
    return ''
  }

  const normalizedOwnerPhone = normalizePhone(ownerPhone)
  const normalizedProxy = normalizePhone(phoneProxy)

  if (normalizedProxy && normalizedProxy === normalizedOwnerPhone) {
    return 'MANAGER'
  }

  const normalizedPhonePublic = normalizePhone(phonePublic)
  if (normalizedPhonePublic && normalizedPhonePublic === normalizedOwnerPhone) {
    return 'DIRECT'
  }

  const normalizedUserPhone = normalizePhone(userPhone)
  if (normalizedUserPhone && normalizedUserPhone === normalizedOwnerPhone) {
    return 'DIRECT'
  }

  return 'MANAGER'
}

export function getClickOwnerCallAmplitudePayload ({
  store,
  lot,
  user,
  callType,
  phoneType,
}: ClickOwnerCallParams): AmplitudePayloadResult {
  if (!lot) {
    return {
      'call type': callType,
      ...(phoneType ? { 'phone type': phoneType } : {}),
    }
  }

  const payload: AmplitudePayloadResult = {
    'call type': callType,
    ...(phoneType ? { 'phone type': phoneType } : {}),
    ...getProductPageSourceFields(lot),
  }

  return appendLotProductOwnerFields(payload, {
    rootGetters: store.getters,
    lot,
    owner: user || lot.user,
    productList: getGlobalPreviewCatalog(),
  })
}
